import { useCallback } from 'react';
import { api } from 'src/constants/apiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

export interface GLCodePeriodDepartment {
  glCdId: number;
  departmentId: number;
  departmentName: string;
}

export interface GLCodeYearDepartment {
  glCdId: number;
  departmentId: number;
  departmentName: string;
}

export interface GLCodePeriodDepartmentResponse {
  clientHasDepartment: boolean;
  buId: string;
  departments: GLCodePeriodDepartment[];
}

const useGLCodeDepartmentApi = (companyId: string) => {
  const call = useCallback(async () => {
    try {
      const res = await axiosInstance.get<GLCodePeriodDepartmentResponse>(
        api.glCodeDepartment(companyId)
      );
      const { clientHasDepartment, departments, buId } = res.data;
      const sortedDepartments = departments.sort((a, b) =>
        a.departmentName.localeCompare(b.departmentName)
      );

      return {
        clientHasDepartment,
        departments: sortedDepartments,
        buId,
      } as GLCodePeriodDepartmentResponse;
    } catch (error) {
      throw new Error(error);
    }
  }, [companyId]);

  const { isLoading, value, execute } = useAsync(
    call,
    false,
    undefined,
    {} as GLCodePeriodDepartmentResponse
  );

  return {
    isLoading,
    glCodeDepartments: value,
    getGlCodeDepartments: execute,
  };
};

export default useGLCodeDepartmentApi;
